import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle
} from "./helper";

export const RequirementsCompletePayee: NotificationAlertOverride = (
  notification,
  history
) => {
  return {
    theme: "success",
    icon: "check-circle",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsCompletePayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsCompletePayee
    ),
    action: createRequirementAction(notification, history)
  };
};
